import {
  FETCH_START,
  FETCH_END,
  FORECAST_LEVEL_DATA_SUCCESS,
  FORECAST_LEVEL_BY_ID,
  FORECAST_LEVEL_DROPDWON_SUCCESS,
  SALES_FORECAST_QUERY_FIELDS_SUCCESS,
  SALES_FORECAST_FORMAT_LIST_SUCCESS,
  SALES_FORECAST_QUERY_SINGLE_SUCCESS,
  SALES_FORECAST_UPLOAD_SUCCESS,
  SALES_FORECAST_DATA_SUCCESS,
  GET_FORECASTS_START,
  GET_FORECASTS_SUCCESS,
  GET_FORECASTS_FAIL,
  GET_FORECAST_BY_ID_START,
  GET_FORECAST_BY_ID_SUCCESS,
  GET_FORECAST_BY_ID_FAIL,
  CREATE_FORECAST_START,
  CREATE_FORECAST_SUCCESS,
  CREATE_FORECAST_FAIL,
  UPDATE_FORECAST_START,
  UPDATE_FORECAST_SUCCESS,
  UPDATE_FORECAST_FAIL,
  DELETE_FORECAST_START,
  DELETE_FORECAST_SUCCESS,
  DELETE_FORECAST_FAIL,
  GET_FORECAST_DATA_START,
  GET_FORECAST_DATA_SUCCESS,
  GET_FORECAST_DATA_FAIL,
  SAVE_FORECAST_DATA_START,
  SAVE_FORECAST_DATA_SUCCESS,
  SAVE_FORECAST_DATA_FAIL,
  EXECUTE_QUERY_START,
  EXECUTE_QUERY_SUCCESS,
  EXECUTE_QUERY_FAIL,
  UPLOAD_FORECAST_DATA_START,
  UPLOAD_FORECAST_DATA_SUCCESS,
  UPLOAD_FORECAST_DATA_FAIL,
  COPY_FORECAST_DATA_START,
  COPY_FORECAST_DATA_SUCCESS,
  COPY_FORECAST_DATA_FAIL,
  EXTERNAL_LOGIN_START,
  EXTERNAL_LOGIN_SUCCESS,
  EXTERNAL_LOGIN_FAIL,
  GET_EXTERNAL_ATTRIBUTES_START,
  GET_EXTERNAL_ATTRIBUTES_SUCCESS,
  GET_EXTERNAL_ATTRIBUTES_FAIL,
  GET_EXTERNAL_QUERIES_START,
  GET_EXTERNAL_QUERIES_SUCCESS,
  GET_EXTERNAL_QUERIES_FAIL,
  GET_FORECAST_ATTRIBUTE_LABELS_START,
  GET_FORECAST_ATTRIBUTE_LABELS_SUCCESS,
  GET_FORECAST_ATTRIBUTE_LABELS_FAIL,
  RUN_SQL_WORKBENCH_START,
  RUN_SQL_WORKBENCH_SUCCESS,
  RUN_SQL_WORKBENCH_FAIL,
  BUDGET_FORECAST_FORMAT_LIST_SUCCESS,
} from '../../actions/Forecasting/ActionTypes';

const initialState = {
  loading: false,
  foreCastLevelData: [],
  foreCastLevelSingleData: [],
  dropdwonForeCast: [],
  forecastformats: [],
  BudgetforecastFormatList: [],
  forecastFormatList: [],
  forecastFormatSingleData: [],
  forecastErrorList: [],
  salesForecastData: [],
  // New Forecast API state
  forecasts: [],
  forecast: null,
  forecastError: null,
  forecastData: null,
  queryResult: null,
  loadingForecasts: false,
  loadingForecast: false,
  loadingForecastData: false,
  loadingQuery: false,
  loadingUpload: false,
  loadingCopy: false,
  // External API state
  externalAttributes: [],
  externalQueries: [],
  forecastAttributeLabels: [],
  sqlWorkbenchResult: null,
  loadingExternalLogin: false,
  loadingExternalAttributes: false,
  loadingExternalQueries: false,
  loadingAttributeLabels: false,
  loadingSQLWorkbench: false,
};

const ForecastingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case FORECAST_LEVEL_DATA_SUCCESS:
      return {
        ...state,
        foreCastLevelData: action.data,
        loading: false,
      };
    case FORECAST_LEVEL_BY_ID:
      return {
        ...state,
        foreCastLevelSingleData: action.data,
        loading: false,
      };
    case FORECAST_LEVEL_DROPDWON_SUCCESS:
      return {
        ...state,
        dropdwonForeCast: action.data,
        loading: false,
      };
    case BUDGET_FORECAST_FORMAT_LIST_SUCCESS:
      return {
        ...state,
        BudgetforecastFormatList: action.data,
        loading: false,
      }
    case SALES_FORECAST_QUERY_FIELDS_SUCCESS:
      return {
        ...state,
        forecastformats: action.data,
        loading: false,
      };
    case SALES_FORECAST_FORMAT_LIST_SUCCESS:
      return {
        ...state,
        forecastFormatList: action.data,
        loading: false,
      };
    case SALES_FORECAST_QUERY_SINGLE_SUCCESS:
      return {
        ...state,
        forecastFormatSingleData: action.data,
        loading: false,
      };
    case SALES_FORECAST_UPLOAD_SUCCESS:
      return {
        ...state,
        forecastErrorList: action.data,
        loading: false,
      };
    case SALES_FORECAST_DATA_SUCCESS:
      return {
        ...state,
        salesForecastData: action.data,
        loading: false,
      };

    // New Forecast API reducers
    case GET_FORECASTS_START:
      return {
        ...state,
        loadingForecasts: true,
      };
    case GET_FORECASTS_SUCCESS:
      return {
        ...state,
        forecasts: action.data,
        loadingForecasts: false,
      };
    case GET_FORECASTS_FAIL:
      return {
        ...state,
        loadingForecasts: false,
      };

    case GET_FORECAST_BY_ID_START:
      return {
        ...state,
        loadingForecast: true,
        forecastError: null,
      };
    case GET_FORECAST_BY_ID_SUCCESS:
      return {
        ...state,
        forecast: action.data,
        loadingForecast: false,
        forecastError: null,
      };
    case GET_FORECAST_BY_ID_FAIL:
      return {
        ...state,
        loadingForecast: false,
        forecast: null,
        forecastError: action.error?.response?.data || action.error?.message || 'Failed to load forecast',
      };

    case CREATE_FORECAST_START:
      return {
        ...state,
        loading: true,
      };
    case CREATE_FORECAST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_FORECAST_FAIL:
      return {
        ...state,
        loading: false,
      };

    case UPDATE_FORECAST_START:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_FORECAST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_FORECAST_FAIL:
      return {
        ...state,
        loading: false,
      };

    case DELETE_FORECAST_START:
      return {
        ...state,
        loading: true,
      };
    case DELETE_FORECAST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_FORECAST_FAIL:
      return {
        ...state,
        loading: false,
      };

    case GET_FORECAST_DATA_START:
      return {
        ...state,
        loadingForecastData: true,
      };
    case GET_FORECAST_DATA_SUCCESS:
      return {
        ...state,
        forecastData: action.data,
        loadingForecastData: false,
      };
    case GET_FORECAST_DATA_FAIL:
      return {
        ...state,
        loadingForecastData: false,
      };

    case SAVE_FORECAST_DATA_START:
      return {
        ...state,
        loading: true,
      };
    case SAVE_FORECAST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_FORECAST_DATA_FAIL:
      return {
        ...state,
        loading: false,
      };

    case EXECUTE_QUERY_START:
      return {
        ...state,
        loadingQuery: true,
      };
    case EXECUTE_QUERY_SUCCESS:
      return {
        ...state,
        queryResult: action.data,
        loadingQuery: false,
      };
    case EXECUTE_QUERY_FAIL:
      return {
        ...state,
        loadingQuery: false,
      };

    case UPLOAD_FORECAST_DATA_START:
      return {
        ...state,
        loadingUpload: true,
      };
    case UPLOAD_FORECAST_DATA_SUCCESS:
      return {
        ...state,
        loadingUpload: false,
      };
    case UPLOAD_FORECAST_DATA_FAIL:
      return {
        ...state,
        loadingUpload: false,
      };

    case COPY_FORECAST_DATA_START:
      return {
        ...state,
        loadingCopy: true,
      };
    case COPY_FORECAST_DATA_SUCCESS:
      return {
        ...state,
        loadingCopy: false,
      };
    case COPY_FORECAST_DATA_FAIL:
      return {
        ...state,
        loadingCopy: false,
      };

    // External API reducers
    case EXTERNAL_LOGIN_START:
      return {
        ...state,
        loadingExternalLogin: true,
      };
    case EXTERNAL_LOGIN_SUCCESS:
      return {
        ...state,
        loadingExternalLogin: false,
      };
    case EXTERNAL_LOGIN_FAIL:
      return {
        ...state,
        loadingExternalLogin: false,
      };

    case GET_EXTERNAL_ATTRIBUTES_START:
      return {
        ...state,
        loadingExternalAttributes: true,
      };
    case GET_EXTERNAL_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        externalAttributes: action.data,
        loadingExternalAttributes: false,
      };
    case GET_EXTERNAL_ATTRIBUTES_FAIL:
      return {
        ...state,
        loadingExternalAttributes: false,
      };

    case GET_EXTERNAL_QUERIES_START:
      return {
        ...state,
        loadingExternalQueries: true,
      };
    case GET_EXTERNAL_QUERIES_SUCCESS:
      return {
        ...state,
        externalQueries: action.data,
        loadingExternalQueries: false,
      };
    case GET_EXTERNAL_QUERIES_FAIL:
      return {
        ...state,
        loadingExternalQueries: false,
      };

    case GET_FORECAST_ATTRIBUTE_LABELS_START:
      return {
        ...state,
        loadingAttributeLabels: true,
      };
    case GET_FORECAST_ATTRIBUTE_LABELS_SUCCESS:
      return {
        ...state,
        forecastAttributeLabels: action.data,
        loadingAttributeLabels: false,
      };
    case GET_FORECAST_ATTRIBUTE_LABELS_FAIL:
      return {
        ...state,
        loadingAttributeLabels: false,
      };

    case RUN_SQL_WORKBENCH_START:
      return {
        ...state,
        loadingSQLWorkbench: true,
      };
    case RUN_SQL_WORKBENCH_SUCCESS:
      return {
        ...state,
        sqlWorkbenchResult: action.data,
        loadingSQLWorkbench: false,
      };
    case RUN_SQL_WORKBENCH_FAIL:
      return {
        ...state,
        loadingSQLWorkbench: false,
      };

    default:
      return state;
  }
};

export default ForecastingReducer;
